export default __webpack_public_path__ + "static/media/ETRUSTED.64feda22.png";